// import { sysPath, moveFile, kill } from '../../services/fileOps'
// import { resize } from '../../services/pictOps'
// import {clone} from '../utils'
// import Marker from './marker'
import {MARK, INSP_FIN} from '../Data/typeDirs'
import {BasicManagedFile} from './basicManagedFile'
// const {} = typeDirs
import {genEntityName} from '../Services/filenameUtils'
// import {
//   deleteDropboxFile,
//   fileCopy,
//   checkDropboxPath,
// } from '../Services/dropbox'
const DROPDIR = '/MetaStoryFiles'

const ARCHDIR = '/Archive'

const PHOTOS_SM = 'photos_sm'

// const LOC_ROOT = `${app.getPath('userData')}/photo_store`


export default class MetaMarker extends BasicManagedFile {
  constructor(args) {
    super(args)


    // this.name = this.name
    this.ext = 'mark'
  }

  static getExt(){
    return 'mark'
  }

  static getIndices(){
    return `${BasicManagedFile.getIndices()},_inspection,_inspectionFinished,_photoId,hidden`
  }

  static getTypeDir(){
    return MARK
  }

  static async delete(fileModels, _id){
    let {Main, Versions} = fileModels[MARK]
    try{
      await Main.findOneAndDelete({_id}).exec()
      await Versions.deleteMany({_parentId:_id}).exec()
    }catch(e){
      console.log('failed deleting report marker', _id, e)
    }
    return
  }

  static async archive(fileModels, _id, markToArchive){
    let {Main, Archive, Versions} = fileModels[MARK]

    let markArchiveCreateRes,
      markVersionsDeleteManyRes,
      markDeleteSelfRes

    try{
      // console.log('do i need markToArchive?', markToArchive)
      if(!markToArchive) markToArchive = await Main.findOne({_id}).exec()
      // console.log('got markToArchive', markToArchive)
      markArchiveCreateRes = await Archive.findOneAndUpdate({_id}, markToArchive, {upsert:true}).exec()
      // console.log('got markArchiveCreateRes')
      markVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
      // console.log('got markVersionsDeleteManyRes')
      markDeleteSelfRes = await Main.deleteOne({_id}).exec()
      // console.log('got markDeleteSelfRes')
    }catch(e){
      console.log( 'failed archiving mark',
        markArchiveCreateRes,
        markVersionsDeleteManyRes,
        markDeleteSelfRes,
        e
      )
    }
    return markToArchive
  }

  // static async archiveFiles(ds, _id, locRoot, kill, token){
  //   let metaMarker = ds('db')[MARK].getTyped({_id})

  //   let inspFin = await ds('remDb')[INSP_FIN].get({_id: metaMarker._inspectionFinished})

  //   let dirName = genEntityName(inspFin.name, inspFin._id)

  //   let from = `${DROPDIR}/${INSP_FIN}/${dirName}/${PHOTOS_SM}/${_id}_sm..jpg`

  //   let to = `${ARCHDIR}/${INSP_FIN}/${dirName}/${PHOTOS_SM}/${_id}_sm..jpg`

  //   // let fromExists = await checkDropboxPath(from, token)

  //   let toExists = await checkDropboxPath(to, token)

  //   if(toExists) await deleteDropboxFile(to, token)

  //       await fileCopy(from, to, token)

  //   await MetaMarker.killDropboxPhoto(ds, _id, token)

  //   await MetaMarker.killLocalPhoto(ds, locRoot, _id, kill)

  // }

  // static async killDropboxPhoto(ds, _id, token){
  //   let metaMarker = ds('db')[MARK].getTyped({_id})

  //   let inspFin = await ds('remDb')[INSP_FIN].get({_id: metaMarker._inspectionFinished})

  //   let dirName = genEntityName(inspFin.name, inspFin._id)
  //   await deleteDropboxFile(`${DROPDIR}/${INSP_FIN}/${dirName}/${PHOTOS_SM}/${_id}_sm.jpg`, token)

  // }

  static async killLocalPhoto(ds, locRoot, _id, kill){
    let metaMarker = ds('db')[MARK].getTyped({_id})

    let inspFin = await ds('remDb')[INSP_FIN].get({_id: metaMarker._inspectionFinished})

    let dirName = genEntityName(inspFin.name, inspFin._id)

    return await kill(`${locRoot}/${INSP_FIN}/${dirName}/${PHOTOS_SM}/${metaMarker._id}_sm.jpg`)

  }

  static async killLocalDBRecords(localdb, _id){
    let res = await localdb[MARK].kill({_id})
    console.log('killing db record for', _id, res)
    return res
  }


  static async unarchive(fileModels, _id, markToUnarchive){
    let {Main, Archive} = fileModels[MARK]

    let markUnarchiveCreateRes,
      // markVersionsDeleteManyRes,
      markDeleteSelfRes

    try{
      // console.log('do i need markToArchive?', markToArchive)
      if(!markToUnarchive) markToUnarchive = await Archive.findOne({_id}).exec()
      // console.log('got markToUnarchive', markToUnarchive)
      markUnarchiveCreateRes = await Main.findOneAndUpdate({_id}, markToUnarchive, {upsert:true}).exec()
      // console.log('got markUnarchiveCreateRes')
      // markVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
      // console.log('got markVersionsDeleteManyRes')
      markDeleteSelfRes = await Archive.deleteOne({_id}).exec()
      // console.log('got markDeleteSelfRes')
    }catch(e){
      console.log( 'failed unarchiving mark',
        markUnarchiveCreateRes,
        markDeleteSelfRes,
        e
      )
    }
    return markToUnarchive
  }

  async getPath(root, dataSource, finsp){
    if (!finsp || !finsp.name || !finsp._id)
      finsp = await dataSource[INSP_FIN].get({_id: this._inspectionFinished})
    // console.log('after getting finsp', finsp, dataSource, dataSource[INSP_FIN])
    const ent = genEntityName(finsp.name, finsp._id)
    const locPath = `${root}/${INSP_FIN}/${ent}/${PHOTOS_SM}`
    return `${locPath}/${this._id}_sm.jpg`
  }

  async getLocalPath(localRoot, finsp, dataSource){
    return await this.getPath(localRoot, dataSource, finsp)

  }

  async getDropboxPath( finsp, dataSource){
    return await this.getPath(DROPDIR, dataSource, finsp)

  }

  static getDropboxPath( finsp, id){
    return `${DROPDIR}/${INSP_FIN}/${genEntityName(finsp.name, finsp._id)}/${PHOTOS_SM}/${id}_sm.jpg`

  }
  static getDropboxArchivePath( finsp, id){
    return `${ARCHDIR}/${INSP_FIN}/${genEntityName(finsp.name, finsp._id)}/photos/${id}.jpg`

  }

  getInspection(){
    let {_inspection} = this.getIds()
    this._inspection = _inspection
    return _inspection
  }

  getFinishedInspection(){
    let {_inspectionFinished} = this.getIds()
    this._inspectionFinished = _inspectionFinished
    return _inspectionFinished
  }

  setInspection(_id){
    this._inspection = _id
    // console.log('setting finished inspection to', _id, this.content)
    this.content.content.data.tree._inspection = {content:[{_name:_id}]}
  }

  setFinishedInspection(_id){
    this._inspectionFinished = _id
    // console.log('setting finished inspection to', _id, this.content)
    this.content.content.data.tree._inspectionFinished = {content:[{_name:_id}]}
  }

  getIds(){
    // console.log('tryna get some ids,', this.content)
    const picLocAddr = '!picLoc'
    let {ownId, _inspection, _inspectionFinished, [picLocAddr]:picLoc, photoId} = this.content.content.data.tree
    // console.log(ownId, ownId.content, _inspection, _inspectionFinished)
    if (ownId && ownId.content) {
      if (Array.isArray(ownId.content)) {
        ownId = ownId.content[0]._name
      } else {
        ownId = ownId.content
      }
    }
    // console.log('we ok ownId')
    if (_inspection && _inspection.content) {
      if (Array.isArray(_inspection.content)) {
        _inspection = _inspection.content[0]._name
      } else {
        _inspection = _inspection.content
      }
    }
    if (photoId && photoId.content) {
      if (Array.isArray(photoId.content)) {
        photoId = photoId.content[0]._name
      } else {
        photoId = photoId.content
      }
    }
    // console.log('we ok _inspection')
    if (_inspectionFinished && _inspectionFinished.content) {
      if (Array.isArray(_inspectionFinished.content)) {
        _inspectionFinished = _inspectionFinished.content[0]._name
      } else {
        _inspectionFinished = _inspectionFinished.content
      }
    }
    // console.log('we ok _inspectionFinished')
    let res = {_id: ownId, _inspection, _inspectionFinished, photoId, [picLocAddr]:picLoc}
    // console.log('returning res', res)
    return res
  }

  getTree(){
    return this.content.getData().data.tree
  }

  validateTree(source, schema){
    this.content.validateTree('data', source, schema)
  }

  getPhotoTime(){
    const tree = this.getTree()
    const leaf = tree.markStart
    const nf = `Unknown time`
    if (!leaf) return nf
    const {content} = leaf
    if (!content || !content.length) return nf
    let val = content[0]._mask || content[0]._name
    const date = new Date(parseInt(val, 10))
    val = `${date.toLocaleDateString()} - ${date.toLocaleTimeString()}`
    return val
  }

  getRoundedTime() {
    const tree = this.getTree()
    const leaf = tree.markStart
    const nf = `Unknown time`
    if (!leaf) return nf
    const {content} = leaf
    if (!content || !content.length) return nf
    let val = content[0]._mask || content[0]._name
    const date = new Date(parseInt(val, 10))
    // console.log('val in date', date)
    const coeff = 1000 * 60 * 5 // 15 minutes
    const rounded = date.getTime() / coeff
    // console.log('rounded time', rounded, Math.round(rounded))
    const finDate = new Date(Math.round(rounded) * coeff)
    val = `${finDate.toLocaleDateString()} - ${finDate.toLocaleTimeString()}`
    return val
  }

  tryGetAttr(attr){
    const tree = this.getTree()
    const leaf = tree[attr]
    const nf = `No ${attr}`
    if (!leaf) return nf
    const {content} = leaf
    if (!content || !content.length) return nf
    let val = content[0]._mask || content[0]._name
    return val
    // if(!res) res = 'WHOOPS'

  }

  serialize(){
    // console.log('serializing marker')
    const superSerialized = super.serialize()
    // console.log('have superSerialized')
    let {_inspectionFinished, photoId, _inspection, [`!picLoc`]:picLoc} = this.getIds()
    // console.log('fetched ids and returning serialization')

    // let _parent = superSerialized.content['data'].source.parentId
    // if( Array.isArray(_parent) ) _parent = _parent[0]
    return {
      ...superSerialized,
      hidden:this.hidden,
      _inspection,
      _inspectionFinished,
      photoId: photoId,
      [`!picLoc`]:picLoc
    }
  }

  getDelta(data) {
    // console.log('get delta', data)
    // console.log(this, this.content)
    let delta = super.getDelta(data)
    let hidden
    if (typeof data.hidden !== 'undefined' && this.hidden !== data.hidden) {
      hidden = data.hidden
    }
    // console.log('marker delta', delta)
    return {delta, hidden}
  }

  applyVersion(versionData) {
    const {delta, hidden} = versionData.patch
    if (typeof hidden !== 'undefined') {
      this.hidden = hidden
    }
    if (delta) {
      versionData.patch = delta
      return super.applyVersion(versionData)
    }
    return this
  }


  construct(data){
    // console.log('construct metamarker with data', data)
    this._inspection= data&&data._inspection
    this._inspectionFinished = data&&data._inspectionFinished
    this.photoId = data&&data.photoId
    this.hidden = data&&data.hidden
    // this.version = data.version===0?1:data.version
    this[`!picLoc`] = data[`!picLoc`]
    // this._inspection= args&&args._inspection
    // this._inspectionFinished = args&&args._inspectionFinished
    this.name = data._id
    this._name = data._id
    const result = super.construct(data)
    if( data.version === 0 ) this.version = 1
    return result
  }


}
